import React, { useEffect, useRef, useState } from 'react';
import { BsDot } from 'react-icons/bs';
import { HiOutlineDotsHorizontal } from 'react-icons/hi';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import moment from 'moment';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MonthlyOverviewJobType = ({ chartOverViewJobTypeData, jobCompany, getMonthlyJobs }: any) => {
    const allFlaggingZero = chartOverViewJobTypeData?.flagging?.every((value: any) => value === 0);
    const allParkingZero = chartOverViewJobTypeData?.parking?.every((value: any) => value === 0);
    const options: any = {
        radius: 0,
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: true,
                // text: "Chart.js Line Chart",
            },
            datalabels: {
                display: true,
                anchor: 'end',
                align: 'top',
                offset: (context: any) => (context.dataset.label === 'Parking' ? -24 : -6),
                color: (context: any) => (context.dataset.label === 'Parking' ? 'black' : 'navy'),
                formatter: (value: any) => (value === 0 ? '' : value),
            },
            tooltip: {
                enabled: false,
            },
        },
        scales: {
            // to remove the labels
            x: {
                ticks: {
                    // display: false,
                },

                // to remove the x-axis grid
                grid: {
                    // drawBorder: false,
                    display: false,
                },
                border: {
                    display: false,
                },
            },
            // to remove the y-axis labels
            y: {
                ticks: {
                    display: false,
                    // beginAtZero: true,
                },
                // to remove the y-axis grid
                grid: {
                    drawBorder: true,
                    display: false,
                },
                border: {
                    display: false,
                },
            },
        },
    };

    const labels = chartOverViewJobTypeData?.months;
    const data = {
        labels,
        datasets: [
            {
                label: 'Parking',
                data: chartOverViewJobTypeData?.parking,
                backgroundColor: '#EFF0F1',
                borderRadius: 20,
            },
            {
                label: 'Flagging',
                data: chartOverViewJobTypeData?.flagging,
                backgroundColor: '#627BE8',
                borderRadius: 20,
            },
        ],
    };

    const chartRef = useRef<any>(null);

    const handleClick = (event: any) => {
        const chart = chartRef.current;

        if (!chart) return;

        const elements = getElementAtEvent(chart, event);

        // No bar clicked
        if (!elements.length) return;

        // Get first clicked element
        const { datasetIndex, index } = elements[0];

        // Get which dataset (Flagging or Parking)
        const datasetLabel = data.datasets[datasetIndex].label;

        let jobTypeID = 0;

        if (datasetLabel === 'Parking') {
            jobTypeID = 1;
        } else {
            jobTypeID = 2;
        }

        const totalMonths = data.labels.length; // e.g. 6

        const currentMonth = moment().startOf('month');

        const selectedMonth = currentMonth.clone().subtract(totalMonths - 1 - index, 'months');

        const startDate = selectedMonth.startOf('month').format('YYYY-MM-DD HH:mm');

        const endDate = selectedMonth.endOf('month').format('YYYY-MM-DD HH:mm');

        // const startDate = moment(month, 'MMM').startOf('month').format('YYYY-MM-DD HH:mm');
        // const endDate = moment(month, 'MMM').endOf('month').format('YYYY-MM-DD HH:mm');
        getMonthlyJobs(`?page=1&limit=10&status=done&startDate=${startDate}&endDate=${endDate}&jobType=${jobTypeID}&sortHour=0`, startDate, endDate, jobTypeID);
    };

    return (
        <div className="w-full lg:flex-1 p-4 bg-white rounded-2xl main-shadow mt-4 max-md:mt-4 max-lg:mt-5">
            <div className="flex justify-between max-md:flex-col max-md:gap-[10px]">
                <div className="flex items-center max-md:justify-between">
                    <h2 className="text-black text-sm font-black">Monthly `Overview</h2>
                    <p className="text-black80 text-xs font-medium ms-1 mt-[2px]">Last 6 month</p>
                </div>
                <div className="flex items-center max-md:justify-between">
                    <div className="flex items-center">
                        <div>
                            <p className="text-zinc-400 text-xs font-normal flex items-center me-2 max-md:-ms-[0.8rem]">
                                <BsDot className="h-8 w-8" />
                                <span className="-ms-2">Parking Hrs</span>
                            </p>
                        </div>
                        <div>
                            <p className="text-zinc-400 text-xs font-normal flex items-center">
                                <BsDot className="h-8 w-8 text-blue-700" />
                                <span className="-ms-2">Flagging Hrs</span>
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center px-[6px] py-1 bg-zinc-100 rounded-lg border border-gray10 ms-5">
                        <HiOutlineDotsHorizontal className=" w-5 h-5" />
                    </div>
                </div>
            </div>
            <div className="w-full monthly-chart h-72 lg:h-[calc(100%-40px)] ">
                {allFlaggingZero && allParkingZero ? (
                    <div className="emptyMessageShow h-72 lg:h-full ">No Records Found</div>
                ) : (
                    <Bar ref={chartRef} options={options} data={data} plugins={[ChartDataLabels]} onClick={handleClick} />
                )}
            </div>
        </div>
    );
};

export default MonthlyOverviewJobType;
